import React, { useEffect } from 'react';
import RNDebugHomeScreen from './RNDebugHomeScreen';

export const MainScreen: React.FC = () => {
  useEffect(() => {
    if (__DEV__) return;

    window.location.href = 'https://m.a-bly.com/';
  }, []);

  if (__DEV__) {
    return <RNDebugHomeScreen />;
  }
  return null;
};
